export default __webpack_public_path__ + "static/media/desk10.5b8638b2.png";